import { render, staticRenderFns } from "./editResource.vue?vue&type=template&id=0c25f4f0&"
import script from "./editResource.vue?vue&type=script&lang=js&"
export * from "./editResource.vue?vue&type=script&lang=js&"
import style0 from "./editResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports